"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWalkMeLanguage = exports.initWalkme = void 0;
function initWalkme(_a) {
    var initialLanguage = _a.initialLanguage, walkmeSrc = _a.walkmeSrc;
    /*
        Changing the walkme language causes the 'walkme_ready' event to fire. So this boolean flag
        makes sure the initial language is only set on init.
      */
    var isInitialLoad = true;
    window.walkme_ready = function () {
        var evt = new Event("walkme-ready");
        window.dispatchEvent(evt);
        isInitialLoad && exports.setWalkMeLanguage(initialLanguage);
        isInitialLoad = false;
    };
    if (walkmeSrc) {
        var walkme = document.createElement("script");
        walkme.type = "text/javascript";
        walkme.async = true;
        walkme.src = walkmeSrc;
        var s = document.getElementsByTagName("script")[0];
        s.parentNode && s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = { smartLoad: true };
    }
}
exports.initWalkme = initWalkme;
exports.setWalkMeLanguage = function (language) {
    var walkme = window.WalkMeAPI;
    if (walkme) {
        var walkMeLanguage = walkMeLanguageMapping[language] || language.toUpperCase();
        if (walkMeLanguage && walkMeLanguage !== walkme.getCurrentLanguage()) {
            walkme.changeLanguage(walkMeLanguage);
        }
    }
};
var walkMeLanguageMapping = {
    "fr-BE": "BE-FR",
    "nl-BE": "BE-NL",
};
exports.default = initWalkme;
